// Facility types for operational log (prevádzkový denník)
// Keep in sync with server/config/facilityTypes.js
export const FACILITY_TYPES = {
    BEZNE: 'BEZNE',
    SKLADKA: 'SKLADKA',
    MALA_KOMPOSTAREN: 'MALA_KOMPOSTAREN',
    ORTUT: 'ORTUT',
};

export const FACILITY_TYPE_LABELS = {
    BEZNE: 'Bežné zariadenie',
    SKLADKA: 'Skládka odpadov',
    MALA_KOMPOSTAREN: 'Malá kompostáreň',
    ORTUT: 'Úložisko odpadovej ortuti',
};

export const FACILITY_TYPE_OPTIONS = Object.entries(FACILITY_TYPE_LABELS).map(([value, label]) => ({ value, label }));
